// src/pages/yachts/special-offers/IndexSpecialOffersPresenter.js
import React from 'react';
import { Row, Col, Button } from 'reactstrap';

import YachtMenu from '../components/YachtMenu';
import Loader from '../../../common/components/Loader';
import OffersTable from './components/OffersTable';

const IndexSpecialOffersPresenter = (props) => (
    <div className="content-inner-wrapper special-offers-page">
        <YachtMenu
            user_role={props.user_role}
            match={props.match}
            history={props.history}
        />

        <div className="content-inner">
            {props.loading ? (
                <Loader style={{ marginTop: '120px' }} />
            ) : (
                <Row>
                    <Col xs="12" lg="9">
                        <div className="d-flex align-items-center mb-3">
                            <h2 className="mb-0">Special Offers</h2>
                            {props.is_admin && (
                                <Button
                                    color="primary"
                                    className="ml-auto"
                                    onClick={props.onCreate}
                                >
                                    + New offer
                                </Button>
                            )}
                        </div>
                        <OffersTable
                            offers={props.offers}
                            isAdmin={props.is_admin}
                            onEdit={props.onEdit}
                            onArchive={props.onArchive}
                            yachtId={props.match.params.id}
                        />
                    </Col>
                </Row>
            )}
        </div>
    </div>
);

export default IndexSpecialOffersPresenter;
